<template>
    <a-dropdown v-model="visible" v-if="$store.state.user.info.delegator && $store.state.user.info.delegator.length">
        <a class="ant-dropdown-link" @click="e => e.preventDefault()">
            <a-icon type="down"/>
        </a>
        <a-menu slot="overlay" @click="handleMenuClick">
            <a-menu-item v-for="vm in ($store.state.user.info.delegator || [])" :key="vm.uid">
                <a-icon type="user" style="color: #67c23a" v-if="vm.isCurrentUser"/>
                <a-icon type="safety-certificate" style="color: #e6a23c" v-else/>
                <span>{{ vm.uid }} </span>
                <span>{{ vm.username }}</span>
            </a-menu-item>
        </a-menu>
    </a-dropdown>
</template>

<script>

import {changeUser} from '@/api/system/delegation';
export default {
    name:'LayoutDelegation',
    props: {
        currentUser: {
            type: String
        }
    },
    data() {
        return {
            visible: false,
            delegatorList: this.$store.state.user.info.delegator || []
        };
    },
    methods: {
        async handleMenuClick(e) {
            this.$emit('fullLoading');
            await changeUser({
                uid: e.key
            }).then((res) => {
                this.visible = false;
                this.$emit('refeshUser', res);
            }).catch(() => {
                this.$emit('fullLoading', 1);
            });
        }
    }
};
</script>

<style scoped>
.ant-dropdown-link .anticon {
    color: white;
}
</style>
